
export enum BusClass {
  ClassOne= 'ClassOne',
  ClassTwo= 'ClassTwo',
  ClassThree= 'ClassThree',
  ClassA= 'ClassA',
  ClassB= 'ClassB',
  SchoolBus= 'SchoolBus',

}